/*
 * massage-session-approval (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { massageSessionApprovals } from "./massage-session-approval.schema"

export type MassageSessionApproval = z.infer<typeof selectMassageSessionApprovalSchema>
export const selectMassageSessionApprovalSchema = createSelectSchema(massageSessionApprovals)

export type MassageSessionApprovalFilters = z.infer<typeof massageSessionApprovalFiltersSchema>
export const massageSessionApprovalFiltersSchema = z.object({
	id:        z.string().optional(),
	patientId: z.string().optional(),
	active:    z.boolean().optional(),
})

export const createMassageSessionApprovalSchema = createInsertSchema(massageSessionApprovals)
	.partial(globalCreateExclude)
export type CreateMassageSessionApproval = z.infer<typeof createMassageSessionApprovalSchema>

export const updateMassageSessionApprovalSchema = createInsertSchema(massageSessionApprovals)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateMassageSessionApproval = z.infer<typeof updateMassageSessionApprovalSchema>
